import * as React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { tooltip } from '../../../../utils/tooltip';
import { useMutationParser } from "../../mutation-parser";
import { useInputContext } from "../../context/input-context";

// by "unit" we mean amino-acid or nucleotide
// each unit is represented by a string with length 1

function MutationModal({close}: {close: () => void}) {

  // Context:

  const {
    multiplePos, multipleUnits,
    setMutations,
  } = useInputContext();

  // State:
  
  const [value, setValue] = useState("");
  const [messages, setMessages] = useState<string[]>([]);
  
  const dirty = value !== "";

  // Input ref - autofocus:
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }, []);

  // Custom hooks:

  const mutationParser = useMutationParser();

  // Callbacks:

  const handleChange = useCallback((ev) => {
    setValue(ev.target.value);
  }, []);

  const handleSubmit = (ev) => {
    // prevent submitting form
    ev.preventDefault();
    const {mutations, messages} = mutationParser(value);
    if (messages.length == 0) {
      setMutations(mutations);
      close();
    }
    // display (or remove) messages
    setMessages(messages);
  }

  const handleBackdropClick = () => {
    if (!dirty) {
      close();
    }
  }

  const multiple = multiplePos || multipleUnits;
  return (
    <Modal isOpen={true} centered={true} fade={false} toggle={handleBackdropClick} className="ll-mutation-textual-modal">
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={close}>
          Textual input of {multiple ? 'mutations' : 'mutation'}
        </ModalHeader>
        <ModalBody>
          <p>
            Insert {multiple ? 'mutations' : 'mutation'} for analysis
            {multiple ? tooltip('mutation_textual_multiple') : tooltip('mutation_textual_single')}
          </p>
          {multiplePos ? (
            <textarea value={value} onChange={handleChange} />
          ) : (
            <input type="text" value={value} onChange={handleChange} className="form-control" placeholder="Example: H289N" ref={inputRef} />
          )}
          <div>
            {messages.map(msg => <p key={msg}>{msg}</p>)}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">Submit</Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

function MutationTextualInput() {
  
  const [open, setOpen] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpen(open => !open);
  }, []);

  return <div>
    <Button onClick={toggleOpen}>Textual input</Button>
    {open && <MutationModal close={toggleOpen} />}
  </div>
}

export default MutationTextualInput;
